<div class="modal-body">
  <div class="card">
    <div class="modal-header modal-close">
      <button type="button" class="close" aria-label="Close" (click)="closeModal()"><span
        aria-hidden="true">&times;</span></button>
    </div>
    <div class="card-header modal-card-header">
      <h4 class="form-section">
        <i class="ft-repeat"></i> {{ 'paymentRequestInformation.title' | translate }}
      </h4>
    </div>
    <div class="card-body">
      <div class="px-3">
        <ul ngbNav #nav="ngbNav" class="nav-tabs">

          <!-- Payment Request - Details -->
          <li ngbNavItem>
            <a ngbNavLink><i class="ft-cpu"></i> {{ 'paymentRequestInformation.details.title' | translate }}</a>
            <ng-template ngbNavContent>
              <app-payment-request-details [currentObjectId]="currentObjectId"></app-payment-request-details>
            </ng-template>
          </li>

          <!-- Payment Request - Audit Trail -->
          <li *ngIf="hasAuditTrailViewPermission" ngbNavItem>
            <a ngbNavLink><i class="ft-search"></i> {{ 'paymentRequestInformation.auditTrail.title' | translate }}</a>
            <ng-template ngbNavContent>
              <app-payment-request-audit-trail [currentObjectId]="currentObjectId"></app-payment-request-audit-trail>
            </ng-template>
          </li>

          <!-- Payment Request - Financial Transactions -->
          <li *ngIf="hasFinancialTransactionsViewPermission" ngbNavItem>
            <a ngbNavLink><i
              class="icon-credit-card"></i> {{ 'paymentRequestInformation.financialTransactions.title' | translate }}</a>
            <ng-template ngbNavContent>
              <app-module-financial-transactions [moduleId]="paymentRequestmoduleId"
                                                 [currentObjectId]="currentObjectId"></app-module-financial-transactions>
            </ng-template>
          </li>
        </ul>
        <div [ngbNavOutlet]="nav"></div>

        <div class="form-actions">
          <button type="button" class="btn btn-secondary btn-raised mr-1 float-right" (click)="closeModal()">
            <i class="ft-x-square"></i> {{ 'buttons.closeText' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
